import { atom } from "jotai";
import type { LegalClassRestriction } from "@models/legalClassRestriction";

export const legalClassRestrictionsAtom = atom<LegalClassRestriction[]>([]);

// No fetch-error or fetching atom by design. A failed list is not an empty
// one, but the page owns the read's status locally (useMountRead): an
// app-scoped error boolean with no reset outlives the unmount and paints a
// stale failure on the next visit before any request has been issued.

export const isProcessingLegalClassRestrictionsAtom = atom<boolean>(false);
